import * as React from "react";
import { useContext, useEffect, useState } from "react";
import { DefaultButton, Panel, PrimaryButton, Stack, TextField } from "@fluentui/react";
import AuthContext from "../../Services/AuthContext";
import NetGrossPicker from "../../Components/NetGrossPicker";

function EditVentureAddon(props) {
    const [user] = useContext(AuthContext);
    const [name, setName] = useState(props.add.addon || '');
    const [netPrice, setNetPrice] = useState(0);
    const [grossPrice, setGrossPrice] = useState(0);
    const [vat, setVat] = useState(0);
    const [netCost, setNetCost] = useState(0);
    const [grossCost, setGrossCost] = useState(0);

    const _submit = (e) => {
        e.preventDefault();
        const data = {addon: name, net_price: netPrice, vat: vat, gross_price: grossPrice, net_cost: netCost, gross_cost: grossCost};
        fetch(`/api/venture/${props.add.venture_id}/addon/${props.add.id}`, {
            method: 'PUT',
            body: JSON.stringify(data),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { props.onSuccess(json); props.dismissPanel(); })
            .catch(err => { console.log(err) })
    }

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='EditVentureAddon'>Edytuj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);


    useEffect(() => {
        setName(props.add.addon || '');
        setNetPrice(props.add.net_price);
        setGrossPrice(props.add.gross_price);
        setVat(props.add.vat);
        setNetCost(props.add.net_cost);
        setGrossCost(props.add.gross_cost);
    }, [props.add])


    return (
        <Panel
            isOpen={props.add}
            onDismiss={props.dismissPanel}
            headerText="Edytuj Dodatek"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id='EditVentureAddon'>
                <TextField required autoFocus label='Nazwa' value={name} onChange={(e) => setName(e.target.value || '')}/>
                <NetGrossPicker net={netPrice} setNet={setNetPrice} gross={grossPrice} setGross={setGrossPrice} vat={vat} setVat={setVat}  prefix={'Cena '}/>
                <NetGrossPicker net={netCost} setNet={setNetCost} gross={grossCost} setGross={setGrossCost} vat={vat} setVat={setVat} hideVat={true} prefix={'Koszt '}/>
            </form>
        </Panel>
    )
}

export default EditVentureAddon;